import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes";
import moment from 'moment';

// Rehydrate from localStorage so a page refresh keeps the session (Redux resets
// on reload, but the token/expiry were persisted at login).
const initialState = {
  error: "",
  sessionToken: localStorage.getItem('sessionToken') || "",
  expiredTime: localStorage.getItem('expiredTime') || "",
  refreshTokenL: localStorage.getItem('refreshToken') || "",
  isAuthenticated: !!localStorage.getItem('sessionToken'),
  loading: false,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      localStorage.setItem('sessionToken', action.payload.accessToken);
      localStorage.setItem('refreshToken', action.payload.refreshToken);
      localStorage.setItem(
        'expiredTime',
        moment().add(action.payload.expiresIn, 'millisecond'),
      );
      state = {
        ...state,
        loading: false,
        sessionToken: action.payload.accessToken,
        expiredTime: moment().add(action.payload.expiresIn, 'millisecond'),
        isAuthenticated: true,
        isUserLogout: false,
      }
      break
    case LOGOUT_USER:
    case LOGOUT_USER_SUCCESS:
      localStorage.removeItem('sessionToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('expiredTime');
      state = { ...state, isUserLogout: true , sessionToken: null}
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false, isUserLogout: false, }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
